import {DEL_CREATE_TABLE_ROW} from '../_CONSTANTS';

export const del_Create_Table_Row = (id) => {
  return {
    type: DEL_CREATE_TABLE_ROW,
    payload: id
  }
}

